import Avatar from './Avatar'

export default Avatar



// WEBPACK FOOTER //
// ./components/avatar/index.js